import { DashboardModule } from '@domain-group/suit-theme'
import useCurrentUser from '@hooks/useCurrentUser'

import useSelector from '@hooks/useSelector'

import type { OrderModel } from '@models/order'

import OrderItemsListItem from '../OrderItemListItem'
import OrderListItemHeader from '../OrderListItemHeader'

interface OrderListItemProps {
  currentUserPayload: ReturnType<typeof useCurrentUser>,
  order: OrderModel,
  orderItemIds: number[],
}

const OrderListItem = (props: OrderListItemProps) => {
  const {
    currentUserPayload, order, orderItemIds,
  } = props

  const orderItems = useSelector(reduxState => reduxState.entities.orderItems)
  const filteredOrderItems = orderItemIds?.map(id => orderItems[id]).filter(item => item)

  return (
    <DashboardModule
      customHeader={<OrderListItemHeader currentUserPayload={currentUserPayload} order={order} />}
    >
      {!filteredOrderItems?.length && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Order Items present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      {!!filteredOrderItems.length && (
        <DashboardModule.ScrollableSection>
          {filteredOrderItems.map(orderItem => (
            <OrderItemsListItem key={orderItem.id} orderItem={orderItem} />
          ))}
        </DashboardModule.ScrollableSection>
      )}
    </DashboardModule>
  )
}

export default OrderListItem
